(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@convivainc/conviva-js-coresdk"), require("bitmovin-player"));
	else if(typeof define === 'function' && define.amd)
		define("bitmovin-player-analytics-conviva", ["@convivainc/conviva-js-coresdk", "bitmovin-player"], factory);
	else if(typeof exports === 'object')
		exports["bitmovin-player-analytics-conviva"] = factory(require("@convivainc/conviva-js-coresdk"), require("bitmovin-player"));
	else
		root["bitmovin"] = root["bitmovin"] || {}, root["bitmovin"]["player"] = root["bitmovin"]["player"] || {}, root["bitmovin"]["player"]["analytics"] = factory(root["Conviva"], root["bitmovin"]["player"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 